import { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import Carousel from "react-multi-carousel";
import Swal from "sweetalert2";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import "../../styles/RedeemPoints.css";
import { axiosGet, axiosPost } from "../../Apis/axiosMethods";

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 5,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2,
    },
};

const getCategoryClass = (category) => {
    switch (category) {
        case "Gift Cards":
            return "bg-gift-cards";
        case "Travel and Experiences":
            return "bg-travel";
        case "Home Essentials":
            return "bg-home-essentials";
        case "Fashion Accessories":
            return "bg-fashion";
        case "Gaming":
            return "bg-gaming";
        case "Tech and Electronics":
            return "bg-tech";
        default:
            return "bg-secondary";
    }
};

const RedeemOfferSlider = () => {
    const { business_id, business_user_id } = useContext(ConfigContext);

    const [data, setData] = useState([]);

    useEffect(() => {

        const getOffers = async () => {
            try {
                const response = await axiosGet(`/Users/GetOfferList`, { random: 1 });

                if (response?.data?.success) {
                    setData(response.data.data || []);
                }
            } catch (error) {
                if (error?.name !== "CanceledError") {
                    console.error("Get offers failed:", error);
                }
            }
        };

        getOffers();
    }, []);

    const sendRequest = (business_redeem_offer_id) => {

        const res = axiosPost(`/Users/RedeemRequest`, {
            business_id,
            business_user_id,
            business_redeem_offer_id
        })

        if (res.data.success) {
            Swal.fire(
                "🎉 Success",
                `You redeemed ${res.data.points} points`,
                "success"
            );
        } else {
            Swal.fire("Warning", res.data.message, "warning");
        }
    };

    return (
        <div className="container mb-4">
            <div className="text-center">
                <h4 className="offer-heading animated-bg">
                    Redeem Your Rewards
                </h4>

                <p className="offer-subheading">
                    Use your earned points to unlock exclusive offers
                </p>
            </div>

            {data.length > 0 && (
                <Carousel
                    responsive={responsive}
                    autoPlay
                    autoPlaySpeed={2500}
                    infinite={data.length > 5}
                    pauseOnHover
                    swipeable
                    draggable
                    keyBoardControl
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                >
                    {data.map((item, index) => (
                        <div
                            key={item?.business_redeem_offer_id || index}
                            className="offer-card"
                        >
                            <div
                                className={`position-absolute top-0 end-0 px-3 py-1 text-white fw-semibold ${getCategoryClass(
                                    item?.business_redeem_offers_category_name
                                )}`}
                                style={{
                                    borderRightBottomRadius: "20px",
                                    borderBottomLeftRadius: "0px",
                                    fontSize: "13px",
                                }}
                            >
                                {item?.business_redeem_offers_category_name || "-"}
                            </div>

                            <Link
                                to={`/MyAccount/RedeemPointsDetails/${item?.business_redeem_offer_id}`}
                            >
                                <div className="offer-image mt-2">
                                    <img
                                        src={item?.business_redeem_offer_image_url}
                                        alt={item?.business_redeem_offer_title || "Redeem offer"}
                                        loading={index < 2 ? "eager" : "lazy"}
                                        decoding="async"
                                        width="180"
                                        height="180"
                                        onError={(e) => {
                                            e.currentTarget.src =
                                                "https://placehold.co/150x150";
                                        }}
                                    />
                                </div>
                            </Link>

                            <Link
                                to={`/MyAccount/RedeemPointsDetails/${item?.business_redeem_offer_id}`}
                            >
                                <h6
                                    className="offer-title"
                                    title={item?.business_redeem_offer_title}
                                >
                                    {item?.business_redeem_offer_title}
                                </h6>
                            </Link>

                            <p className="offer-desc">
                                {item?.business_redeem_offer_description}
                            </p>

                            <div className="d-flex justify-content-between align-items-center w-100 mt-auto">
                                <span className="font-weight-bold text-dark">
                                    {item?.business_redeem_offer_points}{" "}
                                    <small>Points</small>
                                </span>

                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm redeem-btn"
                                    onClick={() =>
                                        sendRequest(item?.business_redeem_offer_id)
                                    }
                                >
                                    Buy it now
                                </button>
                            </div>
                        </div>
                    ))}
                </Carousel>
            )}

            <style>{`
                 .offer-card {
                     padding: 16px;
                     margin: 10px;
                     height: 380px;
                     display: flex;
                     flex-direction: column;
                     box-shadow: 0 8px 20px rgba(0,0,0,.08);
                     transition: transform .3s;
                 }
                 .offer-card:hover {
                     transform: translateY(-5px);
                 }
                 .offer-image {
                     height: 180px;
                     display: flex;
                     align-items: center;
                     justify-content: center;
                     margin-bottom: 10px;
                 }
                 .offer-image img {
                     max-height: 100%;
                     max-width: 100%;
                     object-fit: contain;
                 }
                 .offer-title {
                     font-weight: 600;
                     font-size: 14px;
                     white-space: nowrap;
                     overflow: hidden;
                     text-overflow: ellipsis;
                 }
                 .offer-desc {
                     font-size: 12px;
                     color: #777;
                     display: -webkit-box;       /* enable flex-like box for line clamping */
                     -webkit-line-clamp: 2;      /* show maximum 2 lines */
                     -webkit-box-orient: vertical; 
                     overflow: hidden;           /* hide extra text */
                     text-overflow: ellipsis;    /* show "…" for overflow */
                     word-break: break-word;     /* break long words */
                     cursor: pointer
                 }

                 .points-badge {
                     background: linear-gradient(135deg,#ff9a00,#ff3d00);
                     color: #fff;
                     padding: 6px 12px;
                     border-radius: 20px;
                     font-size: 12px;
                     font-weight: bold;
                 }
                 .btn-buy-now {
                     background: linear-gradient(135deg, #ff0000, #b30000);
                     color: #fff;
                     font-size: 12px;
                     font-weight: 600;
                     padding: 7px 18px;
                     border-radius: 30px;
                     border: none;
                     letter-spacing: .3px;
                     transition: all .25s ease;
                     box-shadow: 0 6px 15px rgba(255, 0, 0, 0.4);
                 }
                 .btn-buy-now:hover {
                     background: linear-gradient(135deg, #ff3b3b, #8b0000);
                     transform: scale(1.06);
                     box-shadow: 0 8px 22px rgba(255, 0, 0, 0.6);
                     color: #fff;
                 }
                        .bg-gaming {
                     background: #014493 !important;
                     color: white !important;
                 }

                     .bg-gifts {
                     background: #b5b780 !important;
                     color: white !important;
                     }
             `}</style>
        </div>
    );
};

export default RedeemOfferSlider;